module.exports = __webpack_public_path__ + "media/packs/components/weployer/jobTypeSelectionModal/rehire_illustration-00ddcc7b0967999e4149442a8ebd8cbd.svg";